window.onWizzyScriptLoaded = function () {

  // Replacing default template
  replaceTemplate("wizzy-search-results-product");
  // replaceTemplate("wizzy-search-results");
  // replaceTemplate("wizzy-search-empty-results");
  replaceTemplate("wizzy-search-wrapper");
  replaceTemplate("wizzy-autocomplete-topproducts");
  // replaceTemplate("wizzy-autocomplete-suggestions");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = !0;
      payload.search.configs.facets.leftFacets.mobileCollapsible = !0;
      window.wizzyConfig.common.isLazyInit = true;
      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
          desktop: 5e3,
          mobile: 1e4
      };

      if(window.document.documentElement.clientWidth < 768){
         window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
            {
                "dom": ".wizzy-search",
                "type": "text"
            }
          ]
      }else {
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
            {
                "dom": "#st-desktop-search-input",
                "type": "text"
            }
          ]
      }

      payload.search.configs.pagination.infiniteScrollOffset = {
                desktop: 5e3,
                mobile: 1e4
            };


      payload.search.configs.facets.configs.push({
        "label": "All Brands",
        "key": "product_view_selection_custom",
        "position": "top",
        "order": 8
      });

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      // window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
      //   {
      //       "dom": "wizzy-search-input",
      //       "type": "text"
      //   }
      // ]
      // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main")

      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = !0;
      payload.search.configs.facets.leftFacets.mobileCollapsible = !0;
      window.wizzyConfig.common.isLazyInit = true;
      // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["#main"];
      // window.wizzyConfig.search.configs.general.minQueryLength = 1;

      payload.search.configs.pagination.infiniteScrollOffset = {
          desktop: 5e3,
          mobile: 1e4
              };

      payload.search.configs.facets.configs.push({
        "label": "All Brands",
        "key": "product_view_selection_custom",
        "position": "top",
        "order": 8
      });

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      // console.log(payload, " <== AFTER_PRODUCTS_TRANSFORMED")

      if(payload){
        payload.forEach(product => {
          
          product.buyFive999 = false;
          product.buyFour999 = false;
          product.buyTwo699 = false;
          product.irresistiblySoft = false;
          product.idealFor15_20degree = false;
          product.clearanceSale = false;
          product.productTitle = "";
          product.productHandle = "";
          if(product.attributes){
            product.attributes.forEach(attribute => {
              if(attribute.id === "product_tags"){
                // if(attribute.values[0].value[0] && attribute.values[0].value[0].includes("Buy 5 @ 999")){
                //   product.buyFive999 = true;
                // }
                // if(attribute.values[0].value[0] && attribute.values[0].value[0].includes("Buy 4 undies @ 999")){
                //   product.buyFour999 = true;
                // }
                if(attribute.values[0].value[0] && attribute.values[0].value[0].includes("_label_Irresistibly Soft")){
                  product.irresistiblySoft = true;
                }
                if(attribute.values[0].value[0] && attribute.values[0].value[0].includes("_label_Ideal for 15-22°C")){
                  product.idealFor15_20degree = true;
                }
                // if(attribute.values[0].value[0] && attribute.values[0].value[0].includes("clearance sale")){
                //   product.clearanceSale = true;
                // }
                // if(attribute.values[0].value[0] && attribute.values[0].value[0].includes("2 t-shirt @ 699 & 3 t-shirt @ 999")){
                //   product.buyTwo699 = true;
                // }
              }
              if(attribute.id === "product_product_title_custom"){
                if(attribute.values[0].value[0]){
                  product.productTitle = attribute.values[0].value[0];
                }
              }
              if(attribute.id === "product_handle"){
                if(attribute.values[0].value[0]){
                  product.productHandle = attribute.values[0].value[0];
                }
              }
              if (attribute.id === "product_view_selection_custom") {
                console.log('crew');
                if (attribute.values[0].value[0]) {
                  product.viewSelection = attribute.values[0].value[0];
                }
              }
            });
            if (product.viewSelection === "crew") {
                product.isCrew = true;
            }
          }
        })
      }

      // payload.forEach((product) => {
      //     // Check if the last three characters of price are '.00' and remove them if necessary
      //     if(product.price){
      //       if (product.price.endsWith('.00')) {
      //         product.price = product.price.slice(0, -3);
      //       }
      //     }
      //     if(product.sellingPrice) {
      //       if (product.sellingPrice.endsWith('.00')) {
      //         product.sellingPrice = product.sellingPrice.slice(0, -3);
      //       }
      //     }
      //     if (product.discount){
      //       if (product.discount.endsWith(".00")) {
      //         product.discount = product.discount.slice(0, -3); // Remove the last three characters
      //       }
      //       // var discountPrice = product.discount;
      //       // if(discountPrice){
      //       //   product.discount = discountPrice.replace(/,/g, '');
      //       // }
      //     }
      // });

      payload.forEach((product) => {
        if (product.price) {
          let value = product.price; // string with commas
          product.price = Math.round(parseFloat(value.replace(/,/g, ''))).toLocaleString(); // Remove commas, convert to float, round, and format with commas
        }
        if (product.sellingPrice) {
          let value = product.sellingPrice; // string with commas
          product.sellingPrice = Math.round(parseFloat(value.replace(/,/g, ''))).toLocaleString(); // Remove commas, convert to float, round, and format with commas
        }
        if (product.discount) {
          let value = product.discount; // string with commas
          product.discount = Math.round(parseFloat(value.replace(/,/g, ''))).toLocaleString(); // Remove commas, convert to float, round, and format with commas
        }
      });

      payload.forEach(product => {
        product.colorSwatch = "";
        if(product.attributes && window.wizzyConfig.common.isOnCategoryPage && !window.collectionMeta.hideColorSwatch){
          product.attributes.forEach(attribute => {
            if(attribute.id === "product_plp_swatches_custom"){
              if(attribute.values[0].value && attribute.values[0].value.length > 1){
                product.colorSwatch = JSON.parse(attribute.values[0].value[1]);

                // console.log("Wizzy product.colorSwatch ===> ",product.id ,product.colorSwatch);

                let swatches = JSON.parse(attribute.values[0].value[1]);

                    if (product.productHandle) {
                        const matchedSwatch = swatches.find(swatch => 
                            swatch.product_url.includes(product.productHandle)
                        );

                        if (matchedSwatch) {
                            matchedSwatch["is-Selected"] = true;
                            swatches = [matchedSwatch, ...swatches.filter(swatch => swatch !== matchedSwatch)];
                        }
                    }

                    swatches.forEach(swatch => {
                      if (swatch.product_url) {
                        // Replace the old domain with the new one
                        const updatedUrl = swatch.product_url.replace('xyxx-apparels.myshopify.com', 'xyxxcrew.com');
                        swatch.product_url = updatedUrl;
                      }
                    });

                    product.colorSwatch = swatches;
              }
            }
          })
        }
      })

      payload.forEach(product => {
        if(product.id){
          product.offers = "";
          product.offersAvailable = false;
          product.textOffer = "";
          product.textOfferAvailable = false;
          var offerText = window.dealOfTheDayOffers[product.id];
          if(offerText){
            if(offerText.includes("Ultra Lightweight - Ultra Smooth") || offerText.includes("8X Faster Drying Performance")){
              product.textOfferAvailable = true;
              product.textOffer = offerText;
            }else {
              product.offersAvailable = true;
              product.offers = offerText;
            }
          }
        }
      })

      payload.forEach(product => {
          if (product.url) {
              // Create a URL object from the product.url and use the 'origin + pathname' to remove query parameters
              const url = new URL(product.url);
              const cleanUrl = url.origin + url.pathname;
              product.url = cleanUrl;
          }
      });
      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload, "BEFORE_AUTOCOMPLETE_EXECUTED");
      // payload.minQueryLength = 1;
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SORT_EXECUTED,
    function (payload) {
      // console.log(payload, "BEFORE_SORT_EXECUTED");
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {
      // console.log(payload, "PRODUCTS_CACHED_RESULTS_RENDERED");
      const bodyEle = document.querySelector("body")
      if(bodyEle){
        bodyEle.classList.add("wizzy-results-cache-rendered")
      }
      return payload;
    }
  );

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");

      if(data && data.payload.products){
        if(data.payload.products.filters){
          if(data.payload.products.filters.q){
            if(data.payload.others && data.payload.others.length > 0 && data.payload.products.filters.q.length > 0){
              data.payload.others = [];
            }
            if (data.payload.categories && data.payload.categories.length > 0 && 
              data.payload.products.filters.q && data.payload.products.filters.q.length > 0) { 
              console.log("comming here",data.payload.categories)
              const removeCategories = ['Thermal Pyjama', 'Boxer Briefs for Men'];
              
              data.payload.categories = data.payload.categories.filter(category => 
                  !removeCategories.includes(category.value)
              );
          }

          }
        }
      }
      
      return data;
    })

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      // console.log(payload,"BEFORE_SEARCH_EXECUTED")

      var mobileSearch = window.document.querySelector("#search-mobile");
      if(mobileSearch){
        mobileSearch.style.display='none';
      }

      const closeButtons = document.querySelectorAll('.wizzy-close-button');
      closeButtons.forEach(function(button) {
          button.click();
      });
      
      return payload;
    }
  );

     window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      console.log(payload.filters,"BEFORE_FILTERS_EXECUTED");

      if (payload.filters && payload.filters.hasOwnProperty('product_Offer_tags[0]')) {
        const value = payload.filters['product_Offer_tags[0]'];
        // console.log("The value of 'product_Offer_tags[0]' is:", value);
        payload.filters.attributes.product_Offer_tags = [value];
      } else {
        console.log("The key 'product_Offer_tags[0]' does not exist.");
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log(data," <= VIEW_RENDERED");

      if (window.wizzyConfig.common.collectionHandle === "undiependence-sale") {
        console.log("Yes Im on collection page undiependence-sale");
        const original = document.querySelector(
            ".wizzy-filters-facet-block.facet-block-product_product_type"
        );

        if (original) {
          const targetContainer = document.querySelector(
            ".wizzy-search-wrapper .wizzy-search-filters-list-top-wiz"
          );

          if (targetContainer) {
            const existingClone = targetContainer.querySelector(
                ".wizzy-filters-facet-block.facet-block-product_product_type.facet-block-top"
            );

            if (!existingClone) {
              const clone = original.cloneNode(true); // true for deep clone
              clone.classList.remove("facet-block-left", "collapsed");
              clone.classList.add("facet-block-top");

              targetContainer.appendChild(clone);
            }
          }
        }
      }


      if(window.document.documentElement.clientWidth < 768){
        const filtersTop = document.querySelector('.wizzy-search-filters-top');
        if (filtersTop) {
            const selectedFilters = filtersTop.querySelector('.wizzy-selected-filters');
            if (selectedFilters) {
                const facetList = selectedFilters.querySelector('.wizzy-selected-facet-list');
                if (facetList) {
                    const offerTagItem = facetList.querySelector('li[data-facetkey="product_Offer_tags"]');

                    if (offerTagItem) {
                        selectedFilters.style.display = 'block';
                        filtersTop.style.position = 'relative';

                        const allFacetItems = facetList.querySelectorAll('li');
                        allFacetItems.forEach(function(item) {
                            if (item.getAttribute('data-facetkey') !== 'product_Offer_tags') {
                                item.style.display = 'none';
                            } else {
                                item.style.display = 'list-item';
                            }
                        });
                    }
                }
            }
        }
      }


     // Get references to the elements
    const dropdownButton = document.querySelector('.dropbtn');
    const dropdown = dropdownButton.closest('.dropdown'); // Parent of the button
    const dropdownContent = dropdown.querySelector('.dropdown-content');

    // Track the event attachment state by adding a class to the dropdown
    dropdown.classList.add('dropdown-event-attached');

    // Toggle the 'open' attribute on click
    dropdownButton.addEventListener('click', function(event) {
        // Prevent click event from propagating to document
        event.stopPropagation();
        
        // Check if the dropdown is already open and toggle the 'open' attribute
        if (dropdown.hasAttribute('open')) {
            dropdown.removeAttribute('open');
        } else {
            dropdown.setAttribute('open', 'true');
        }
    });

    // Close the dropdown if the click happens outside
    document.addEventListener('click', function(event) {
        if (!dropdown.contains(event.target)) {
            dropdown.removeAttribute('open');
        }
    });

    if (window.innerWidth < 768) {
      var filterBtnTop = document.querySelector('.filter-sort-btn');

      if (filterBtnTop) {
        filterBtnTop.addEventListener('click', function(){
          var filterBtnBottom = document.querySelector('.wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-filters-mobile-entry');
          if (filterBtnBottom) {
            filterBtnBottom.click();
          }
        });
      }

      var container = document.querySelector(".wiz-container");
      var allBrandsFilter = document.querySelector(".wizzy-search-filters-left .wizzy-filters-facet-block.facet-block-product_view_selection_custom.facet-block-left");

      if (container && allBrandsFilter && !container.querySelector(".facet-block-product_view_selection_custom")) {
        container.insertAdjacentElement("afterbegin", allBrandsFilter);
      }

      const allBrandsTitle = document.querySelector(".wiz-container .wizzy-filters-facet-block.facet-block-product_view_selection_custom .facet-head-title");

      if (allBrandsTitle && !allBrandsTitle.querySelector("svg.wizzy-down-arrow")) {
        allBrandsTitle.insertAdjacentHTML("beforeend", `
          <svg class="wizzy-down-arrow" width="800px" height="800px" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg" 
              style="width: 30px; height: 30px; margin-bottom: 2px;">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289C6.68342 7.90237 7.31658 7.90237 7.70711 8.29289L12 12.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L12.7071 14.7071Z"
                  fill="#fff"></path>
          </svg>
        `);
      }

    }

    if (window.innerWidth < 768) {
      var sourceElement = document.querySelector(".wizzy-search-sort-wrapper");
      if (sourceElement) {
          var clonedContent = sourceElement.cloneNode(true);
          var targetDiv = document.querySelector(".wizzy-sort-wrapper-in-filter");
          if (window.innerWidth < 768) {
              if (targetDiv && !targetDiv.querySelector(".wizzy-search-sort-wrapper")) {
                  targetDiv.appendChild(clonedContent);
              }
          }
          else {
              if (targetDiv) {
                  var clonedSort = targetDiv.querySelector(".wizzy-search-sort-wrapper");
                  if (clonedSort) {
                      clonedSort.remove();
                  }
              }
          }
      }

      // const filterHeaderTitle = document.querySelector(".wizzy-search-filters-left .wizzy-filters-header .header-title");
      // if (filterHeaderTitle) {
      //     filterHeaderTitle.textContent = "Filter and sort";
      // }

      var sortInFilter = document.querySelector(".wizzy-search-filters-left-wrapper .wizzy-sort-wrapper-in-filter");
      if (sortInFilter && !sortInFilter.classList.contains("click-listener-attached")) {
          sortInFilter.addEventListener("click", function(event) {
              event.preventDefault();
              event.stopPropagation();
              var sortOptions = document.querySelector(".wizzy-common-select-options");
              if (sortOptions) {
                if (sortOptions.style.display === 'none' || sortOptions.style.display === '') {
                    sortOptions.style.display = 'grid';
                } else {
                    sortOptions.style.display = 'none';
                }
              }
          });
          sortInFilter.classList.add("click-listener-attached");
      }

      // var hoverElement = document.querySelector(".wizzy-common-select-container > .wizzy-common-select-selector");
      // if (hoverElement && !hoverElement.classList.contains("click-listener-attached")) {
      //     hoverElement.addEventListener("click", function(event) {
      //         var sortOptions = document.querySelectorAll(".wizzy-common-select-options");
      //         if (sortOptions.length > 1) {
      //             if (
      //                 sortOptions[1].style.display === "none" ||
      //                 sortOptions[1].style.display === ""
      //             ) {
      //                 sortOptions[1].style.display = "grid";
      //                 sortOptions[0].style.display = "none";
      //             }
      //             else {
      //                 sortOptions[1].style.display = "none";
      //             }
      //         }
      //     });
      //     hoverElement.classList.add("click-listener-attached");
      // }
    }

    
    const options = document.querySelectorAll('.wizzy-search-filters-left-wrapper .wizzy-common-select-option');
    if (options && options.length) {
      options.forEach((option, index) => {
        option.addEventListener('click', () => {
          console.log(`Clicked option index: ${index}`);

          options.forEach(o => o.classList.remove('selected'));
          option.classList.add('selected');

          const otherOptions = document.querySelectorAll('.search-filters-top-wrapper .wizzy-common-select-option');
          
          if (otherOptions && otherOptions[index]) {
            console.log(`Triggering click on corresponding option in .search-filters-top-wrapper at index ${index}`);
            otherOptions[index].click();
          } else {
            console.warn(`No corresponding option found at index ${index} inside .search-filters-top-wrapper`);
          }
        });
      });
    }

    const facetBlock = document.querySelector('.wiz-container .wizzy-filters-facet-block');
    if (facetBlock && facetBlock.classList.contains('collapsed')) {
      facetBlock.classList.remove('collapsed');
      console.log('Removed "collapsed" class from .wizzy-filters-facet-block');
    }


    //////////////////////////////////////////////////////

    const searchFiltersTop = document.querySelector('.wizzy-search-filters-top');

    if (searchFiltersTop) {
      const countElements = searchFiltersTop.querySelectorAll(
        '.search-filters-top-wrapper .wizzy-facet-list-item-count'
      );

      let totalCount = 0;
      countElements.forEach(el => {
        const num = parseInt(el.textContent.replace(/[()]/g, '').trim(), 10);
        if (!isNaN(num)) totalCount += num;
      });

      const facetTitle = searchFiltersTop.querySelector('.facet-head-title');

      if (facetTitle) {
        if (!facetTitle.nextElementSibling?.classList.contains('facet-total-count')) {
          const totalSpan = document.createElement('span');
          totalSpan.textContent = `(${totalCount})`;
          totalSpan.style.marginLeft = '5px';
          totalSpan.classList.add('facet-total-count');
          facetTitle.insertAdjacentElement('afterend', totalSpan);
          console.log(`Added total count (${totalCount}) next to facet-head-title`);
        }
      }
    }

    ///////////////////////////////////////////////////////////

    const wizContainer = document.querySelector('.wiz-container');

    if (wizContainer) {
      const facetBlock = wizContainer.querySelector('.wizzy-filters-facet-block');
      
      if (facetBlock) {
        const countElements = facetBlock.querySelectorAll('.wizzy-facet-list-item-count');
        
        let totalCount = 0;
        countElements.forEach(el => {
          const num = parseInt(el.textContent.replace(/[()]/g, '').trim(), 10);
          if (!isNaN(num)) totalCount += num;
        });

        const facetTitle = facetBlock.querySelector('.facet-head-title');
        const svgIcon = facetTitle?.querySelector('svg');

        if (facetTitle) {
          if (!facetTitle.querySelector('.facet-total-count')) {
            const totalSpan = document.createElement('span');
            totalSpan.textContent = `(${totalCount})`;
            totalSpan.style.marginLeft = '5px';
            totalSpan.classList.add('facet-total-count');

            if (svgIcon) {
              facetTitle.insertBefore(totalSpan, svgIcon);
            } else {
              facetTitle.appendChild(totalSpan);
            }

            console.log(`Added total count (${totalCount}) inside .facet-head-title`);
          }
        } else {
          console.warn('No .facet-head-title found inside .wizzy-filters-facet-block');
        }
      } else {
        console.warn('No .wizzy-filters-facet-block found inside .wiz-container');
      }
    }

      
      return data;
    }
  );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      console.log(payload,"BEFORE_RENDER_RESULTS");

      defaultOrder = ["XS", "S", "M", "M/L" , "L", "XL", "XXL", "3XL", "4XL", "5XL", "6XL", "7XL", "8XL"]

      if(payload.response.payload.facets){
        payload.response.payload.facets.forEach(facet => {
          if(facet.key === "product_Size"){
            let allSizes = facet.data;

           const standardSizes = [];
            const numericalSizes = [];
            
            allSizes.forEach(size => {
                if (defaultOrder.includes(size.label)) {
                    standardSizes.push(size);
                } else {
                    numericalSizes.push(size);
                }
            });

            standardSizes.sort((a, b) => defaultOrder.indexOf(a.label) - defaultOrder.indexOf(b.label));
            numericalSizes.sort((a, b) => parseInt(a.label) - parseInt(b.label));
            const sortedSizes = [...standardSizes, ...numericalSizes];

            facet.data = sortedSizes
            
          }
        })
      }
    
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      return payload;
    }
  );
};

// Declaration of template replace function
const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};


//////////////////////////////////////////////////////////////////

// Get the elements
// const searchIcon = document.querySelector('.st-search-icon');
// const searchMobile = document.querySelector('#search-mobile');

// // Add a click event listener to the search icon
// searchIcon.addEventListener('click', () => {
//     if (searchMobile.style.display === 'block') {
//         searchMobile.style.display = 'none'; // Hide if it's visible
//     } else {
//         searchMobile.style.display = 'block'; // Show if it's hidden
//     }
// });

/////////////////////////////////////////////

window.addEventListener('scroll', function() {
  if (document.body) { // Check if the body exists
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercentage = (scrollPosition / documentHeight) * 100;

    if (scrollPercentage >= 1) {
      document.body.classList.add('wizzy-scrolled'); // Add your class here
    } else {
      document.body.classList.remove('wizzy-scrolled'); // Optionally, remove class when scrolling back above 1%
    }
  }
});


///////////////////////////////////////////////////

let seachIcon = document.querySelector(".st-search-icon");

if(seachIcon){
  seachIcon.addEventListener("click", function(){
    let mobileSearchBar = document.querySelector(".wizzy-search.wizzy-search-input-abc");
    if(mobileSearchBar){
      setTimeout(function(){
        mobileSearchBar.click();
        mobileSearchBar.focus();
      },500)
    }
  });
}


//////////////////////////////////////////////////////////////


